<template>
  <div style="padding: 10px">

    <!-- 查询区域 -->
    <a-row :gutter="12">
      <a-col :span="12">
        <div style="margin-bottom: 10px;font-size: 18px">
          成本分类
        </div>
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">

              <a-col :xl="12">
                <a-form-item label="成本字典名称">
                  <a-input placeholder="请输入成本字典名称" v-model="queryParam.name"></a-input>
                </a-form-item>
              </a-col>

              <a-col :xl="12" >
                <a-form-item label="成本字典code">
                  <a-input placeholder="请输入成本字典code" v-model="queryParam.code"></a-input>
                </a-form-item>
              </a-col>

              <a-col :xl="12" >
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
            <span slot="check" slot-scope="text, record" >
                <a-radio :checked="record.id===currentCost.id "></a-radio>
              </span>
            <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleConfigItem(record)">配置明细</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <temp-configCostCategory-modal ref="modalForm" @ok="modalFormOk"></temp-configCostCategory-modal>
      </a-col>
      <a-col :span="12">
        <temp-config-cost-item-list :cost-category="currentCost"></temp-config-cost-item-list>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less'
import TempConfigCostCategoryModal from './modules/TempConfigCostCategoryModal.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TempConfigCostItemList from '@views/tempconfig/costCategory/TempConfigCostItemList.vue'

export default {
  name: "TempConfigCostCategoryList",
  mixins:[JeecgListMixin],
  components: {
    TempConfigCostItemList,
    TempConfigCostCategoryModal
  },
  data () {
    return {
      description: '成本字典管理页面',
      // 表头
      columns: [
        {
          title: '',
          dataIndex: 'action2',
          width:35,
          align:"center",
          scopedSlots: { customRender: 'check' },
        },
        {
          title: '成本字典名称',
          align:"center",
          width:300,
          dataIndex: 'name'
        },
        {
          title: '成本字典code',
          align:"center",
          dataIndex: 'code'
        },
        // {
        //      title: '描述',
        //   ellipsis: true, //表格省略
        //      align:"center",
        //      dataIndex: 'description'
        //     },
        {
          title: '操作',
          dataIndex: 'action',
          width:120,
          align:"center",
          scopedSlots: { customRender: 'action' },
        }
      ],
      url: {
        list: "/tempconfig/tempConfigCostCategory/list",
        delete: "/tempconfig/tempConfigCostCategory/delete",
      },
      currentCost:{}
    }
  },
  computed: {
  },
  methods: {
    handleConfigItem(record){
      this.currentCost = record
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>